
import { defineComponent, computed } from 'vue';
import { useStoreState } from '@/hooks/useStoreState';
import {
  REGEX_CAMEL_TO_SPACE,
  REGEX_UNDERSCORE_TO_SPACE,
  REGEX_CAPITALIZE_WORD
} from '@/utils/constants';
import { LocalizationState } from '@/store/modules/LocalizationModule';
import {useTranslations} from "@/hooks/useTranslations";

export default defineComponent({
  name: 'VGenericErrorTable',
  props: {
    data: {
      type: Array as () => Array<Record<string, any>>,
      required: true
    }
  },
  setup(props) {
    const translations = useTranslations();

    const columns = computed(() => {
      const excluded = ['id', 'errors'];
      if (!props.data.length) return [];

      return Object.keys(props.data[0]).filter(
        (key) => !excluded.includes(key.toLowerCase())
      );
    });

    const formatHeader = (key: string): string => {
      return key
        .replace(REGEX_CAMEL_TO_SPACE, '$1 $2')
        .replace(REGEX_UNDERSCORE_TO_SPACE, ' ')
        .replace(REGEX_CAPITALIZE_WORD, (char) => char.toUpperCase())
        .trim();
    };

    return {
      columns,
      formatHeader,
      translations
    };
  }
});
